import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import InputMultiline from '../../components/InputMultiline';
import FormButtons from '../../components/FormButtons';
import useFields from '../../hooks/useFields';
import { formatValuesLoad } from '../index/values';
import routes from '../../../../../../../components/Routes/routingMap';

export const Description = styled.div`
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  color: var(--text-text02);
  margin-bottom: 24px;
  span {
    margin-left: 3px;
    font-weight: 400;
    font-size: 14px;
    color: #5b36f2;
  }
`;

interface BseAdditionalInformationProps {
  idRequest: number;
  save: (
    formName: string,
    fields: any,
    isComplete: boolean,
    save: boolean
  ) => void;
  next: () => void;
}

const BseAdditionalInformation = (props: BseAdditionalInformationProps) => {
  const { idRequest, next, save } = props;
  const [validateForm] = useState(0);
  const formBse = useSelector((state: any) => state.getFormBse);
  const { formAdditionalInformation } = formatValuesLoad(formBse?.data);
  const { fields, setFieldValue, setFieldError, formIsEmpty } = useFields(
    formAdditionalInformation
  );
  const { additionalInformation } = fields;
  const history = useHistory();

  const saveForm = () => {
    save('additionalInformation', fields, true, true);
  };

  const getProps = () => ({
    setFieldError,
    setFieldValue,
    validateOnStart: false,
    validateForm
  });

  const handlerRedirect = () => {
    history.push(
      routes.student.procedures.categories.scholarships.bse.progress
    );
  };

  React.useEffect(() => {
    if (idRequest > 0 && !formIsEmpty) {
      save('additionalInformation', fields, true, false);
    }
  }, [idRequest, formIsEmpty]);
  if (!formBse?.data) return null;
  return (
    <div style={{ padding: '16px 24px' }}>
      <Description>
        Situación adicional <span>(Este dato es opcional)</span>
      </Description>
      <InputMultiline
        isRequired={false}
        nameLabel="*Sí, deseo ampliar la información que se ha brindado en la declaración
        jurada familiar o adicionar información que se considere importante
        sobre alguna situación en particular"
        value={additionalInformation}
        name="additionalInformation"
        {...getProps()}
      />

      <FormButtons
        handlerSend={saveForm}
        handlerNext={next}
        handlerRedirect={handlerRedirect}
        isFinished
        formIsValid
      />
    </div>
  );
};

export default BseAdditionalInformation;
